import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DEFAULT_WIND_IN_DURATION_MIN, DEFAULT_WIND_IN_DURATION_MAX, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { Control } from "../../../control/control";
import { useDispatch } from "react-redux";
import { Range } from "../../../range/range";
import { setWindGustsInDurationMax, setWindGustsInDurationMin, } from "../../../../features/config/config.slice";
import { ControlGroup } from "../../../controlGroup/controlGroup";
import { Group } from "../../../group/group";
export const SnowflakeGustInDuration = ({ index, layer, }) => {
    const dispatch = useDispatch();
    return (_jsx(_Fragment, { children: _jsx(Group, { colour: "secondary", name: "Duration", children: _jsxs(ControlGroup, { children: [_jsx(Control, { name: "Minimum", tooltip: "The minimum duration of a gust", showOutput: true, reset: () => {
                            const min = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].wind.gusts.in.duration.min
                                : DEFAULT_WIND_IN_DURATION_MIN;
                            dispatch(setWindGustsInDurationMin({
                                index,
                                min,
                            }));
                        }, value: layer.wind.gusts.in.duration.min, onChange: (event) => dispatch(setWindGustsInDurationMin({
                            index,
                            min: Number(event.target.value),
                        })), children: _jsx(Range, { min: 0, max: 100, step: 1 }) }), _jsx(Control, { name: "Maximum", tooltip: "The maximum duration of a gust", showOutput: true, reset: () => {
                            const max = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].wind.gusts.in.duration.max
                                : DEFAULT_WIND_IN_DURATION_MAX;
                            dispatch(setWindGustsInDurationMax({
                                index,
                                max,
                            }));
                        }, value: layer.wind.gusts.in.duration.max, onChange: (event) => {
                            dispatch(setWindGustsInDurationMax({
                                index,
                                max: Number(event.target.value),
                            }));
                        }, children: _jsx(Range, { min: "0", max: "100", step: "1" }) })] }) }, index) }));
};
